export const scrollNearestScrollableToTop = (
    node: HTMLElement | null
): void => {
    while (node) {
        const {overflowY} = window.getComputedStyle(node);
        if (overflowY === 'auto' || overflowY === 'scroll') {
            node.scrollTop = 0;
            return;
        }
        node = node.parentElement;
    }

    window.scrollTo(0, 0);
};
